import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBodycare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.87549 2.04338C9.22064 2.04338 9.50049 2.32323 9.50049 2.66838C9.50027 3.0134 9.2205 3.29338 8.87549 3.29338H7.00049V5.83C9.118 6.13563 10.7505 7.94018 10.7505 10.1423V21.3923C10.7507 21.7373 10.4713 22.0171 10.1263 22.0173H2.62549C2.28057 22.0175 2.00074 21.7381 2.00049 21.3931V10.1423C2.00049 7.94018 3.63297 6.13563 5.75049 5.83V3.29338H5.12549C4.78047 3.29338 4.50071 3.0134 4.50049 2.66838C4.50049 2.32323 4.78034 2.04338 5.12549 2.04338H8.87549ZM3.25049 18.2673V20.7673H9.50049V18.2673H3.25049ZM3.25049 12.0434V17.0173H9.50049V12.0434H3.25049ZM6.37549 7.01733C4.64962 7.01733 3.25049 8.41647 3.25049 10.1423V10.7934H9.50049V10.1423C9.50049 8.41647 8.10135 7.01733 6.37549 7.01733Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.373 2.01733C21.7176 2.01703 21.9969 2.29617 21.9972 2.64071C21.9972 2.65051 21.9969 2.66025 21.9964 2.67L21.3755 16.3915V21.3923C21.3757 21.7373 21.0963 22.0171 20.7513 22.0173H13.8755C13.5305 22.0175 13.2507 21.7381 13.2505 21.3931V16.3964L12.5978 2.67163C12.581 2.3275 12.8461 2.03493 13.1903 2.01815C13.2006 2.01764 13.2109 2.01733 13.2212 2.01733H21.373ZM14.5005 17.0173V20.7673H20.1255V17.0173H14.5005ZM13.8771 3.26733L14.4712 15.7673H20.154L20.7188 3.26733H13.8771Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "currentColor"
	})]
});
export default SvgBodycare;
